// use xmlToJson to convert element to json
// use jsonToXml to convert json to html
// node types
  // Node.ELEMENT_NODE	              1	An Element node like <p> or <div>.
  // Node.TEXT_NODE	                  3	The actual Text inside an Element or Attr.
  // Node.CDATA_SECTION_NODE	        4	A CDATASection, such as <!CDATA[[ … ]]>.
  // Node.PROCESSING_INSTRUCTION_NODE	7	A ProcessingInstruction of an XML document, such as <?xml-stylesheet … ?>.
  // Node.COMMENT_NODE	              8	A Comment node, such as <!-- … -->.
  // Node.DOCUMENT_NODE	              9	A Document node.
  // Node.DOCUMENT_TYPE_NODE	       10	A DocumentType node, such as <!DOCTYPE html>.
  // Node.DOCUMENT_FRAGMENT_NODE	   11	A DocumentFragment node.


// Changes XML to JSON
function xmlToJson(xml) {
	// Create the return object
  var obj = {tagName:xml.tagName};
	if (xml.nodeType == 1) {        // type 1 "element" like <p>
		// do its attributes
		if (xml.attributes.length > 0) {
		  obj["attributes"] = {};
			for (var j = 0; j < xml.attributes.length; j++) {
				var attribute = xml.attributes.item(j);
        		obj["attributes"][attribute.nodeName] = attribute.nodeValue;
			}
		}
	} else if (xml.nodeType == 3) { // type 3 "text"
		obj = xml.nodeValue;
	}
	if (xml.hasChildNodes()) {      // has children
		for(var i = 0; i < xml.childNodes.length; i++) {
			var item = xml.childNodes.item(i);          // get item
			var nodeName = item.nodeName;               // get node name
			if (typeof(obj[nodeName]) == "undefined") { // not defined
				obj[nodeName] = xmlToJson(item);          // define by assigning data recursively
			}else{
				if (typeof(obj[nodeName].push) == "undefined") { // obj[nodeName] not array
					var old = obj[nodeName];                       // get old data
					obj[nodeName] = [];                            // make it an array
					obj[nodeName].push(old);                       // add old data
				}
				obj[nodeName].push(xmlToJson(item));             // add new data recursively
			}
		}
	}
	return obj;
 };
function jsonToXml(domJson){
    var attr = ""
    var val  = ""
    for (var el in domJson){
        if (el == 'tagName'){

        }else if (el == 'attributes'){
            var attr = Object.entries(domJson[el]).map(a=>`${a[0]}="${a[1]}"`).join(' ')
        }else if (el == '#text' ){
            return `<${domJson.tagName.toLowerCase()} ${attr}>${domJson[el]}</${domJson.tagName.toLowerCase()}>`
        }else if (Array.isArray(domJson[el]) ){ // array
            for (var b=0;b<domJson[el].length;b++){
                val += jsonToXml(domJson[el][b],el);
            }
        }else{
            val = jsonToXml(domJson[el],el);
        }
    }
    return `<${domJson.tagName.toLowerCase()} ${attr}>${val}</${domJson.tagName.toLowerCase()}>`
 };
// console.log(module.exports)
// if (module.exports){
	module.exports = {xmlToJson, jsonToXml}
// }else{
// 	export {xmlToJson, jsonToXml}
// }


// var domJson = xmlToJson($0); //element to json
// console.log(domJson)

// var htmlStr = jsonToXml(domJson) // json with root tagName
// console.log(htmlStr)
